export default __webpack_public_path__ + "static/media/location-laptop.c7d4887d.png";